import type { Asset } from '../asset';
import {
  buildDownloadSelection,
  type DownloadSelection,
} from './downloadSelection';

export class DownloadSelectionFactory {
  empty = (): DownloadSelection => buildDownloadSelection([]);

  fromAssets = (assets: readonly Asset[]): DownloadSelection =>
    buildDownloadSelection(assets);
}
